export const vipTele2Path = '/vip-tele2'
